import { render, staticRenderFns } from "./BarCard.vue?vue&type=template&id=9b406638&scoped=true&"
import script from "./BarCard.vue?vue&type=script&lang=js&"
export * from "./BarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b406638",
  null
  
)

export default component.exports